import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Logout } from "./store/action";
import MainLayout from "./main";
import AdminLayout from "./admin";

function App() {
  const [auth, setAuth] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (auth) {
      navigate("/admin");
      dispatch(Logout());
    }
    return () => {
      setAuth(false);
    };
  }, [auth, dispatch, navigate]);

  const constantMock = window.fetch;
  window.fetch = function () {
    let response;

    return new Promise((resolve, reject) => {
      constantMock
        .apply(this, arguments)
        .then((response) => {
          if (response.status === 401) {
            setAuth(true);
          }

          return resolve(response);
        })
        .catch((error) => {
          reject(response);
        });
    });
  };
  return (
    <Routes>
      <Route
        path="/admin/*"
        element={<AdminLayout render={(props) => ({ ...props })} />}
      />
      <Route
        exact
        path="/*"
        element={<MainLayout render={(props) => ({ ...props })} />}
      />
    </Routes>
  );
}

export default App;
